import styled from "styled-components";
import backgroundHeader from "../../assets/EuphaWorld/backgroundHeader.png";

export const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  height: 400px; /* Adjust height as needed */
  background: url(${backgroundHeader}) center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-family: Arial, sans-serif;
  text-transform: uppercase;

  @media (max-width: 550px) {
    /* Phones */
    height: 250px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    height: 250px;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0); /* Dark overlay */
`;

export const TextContainer = styled.div`
  position: relative;
  text-align: left;
`;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 2px;
  margin-top: -1.6em;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 1.5em;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 1.5em;
  }
`;

export const Highlighted = styled.span`
  color: red;
  font-weight: bold;
`;

export const FullTitle = styled.div`
  font-size: 8rem;
  font-weight: bold;
  padding-top: 1em;
  opacity: 0.3;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 4rem;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 4rem;
  }
`;